import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Currency, DataTypeOptions, SavingOrInvestment } from '@core/constants/data-types.constants';
import { getFieldError, isFieldInvalid, isFieldValid } from '@shared/utils/forms/validations.util';

@Component({
  selector: 'mfp-saving-or-investment',
  templateUrl: './saving-or-investment.component.html',
  styleUrls: ['./saving-or-investment.component.scss']
})
export class SavingOrInvestmentComponent {
  @Input() form: FormGroup = new FormGroup({});
  @Input() view = 'agent';
  @Input() label = '';
  @Input() readonly = false;
  @Input() required = false;

  @Input() amountName = '';
  @Input() currencyOptions: DataTypeOptions<Currency> = [];
  @Input() amountLabel = '';

  @Input() typeName = '';
  @Input() typeLabel = '';
  @Input() typePlaceholder = '';
  @Input() typeOptions: DataTypeOptions<SavingOrInvestment> = [];
  @Input() typeColor: 'primary' | 'light' = 'primary';

  @Input() mandatoryFieldMessage = '';

  @Input() removeLabel = '';
  @Input() removeFill: 'default' | 'clear' | 'outline' = 'clear';
  @Input() removeSize: 'medium' | 'small' | 'tiny' = 'tiny';
  @Input() removeIcon = 'assets/icons/delete.svg';
  @Input() removeIconPosition: 'left' | 'right' = 'left';
  @Output() removeItem = new EventEmitter();

  isFieldValid = isFieldValid;
  isFieldInvalid = isFieldInvalid;
  getFieldError = getFieldError;

  remove(): void {
    this.removeItem.emit();
  }
}
